module.exports = __webpack_public_path__ + "static/media/icon.a6d7b05b.png";